import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authToken } from '../guards/auth-token.guard';
import { requiredPrivilege } from '../guards/required-privilege.guard';

import { CsrAccountComponent } from './components/csr-account/csr-account.component';
import { ClientDashboardTilesComponent } from './components/client-dashboard-tiles/client-dashboard-tiles.component';
import { RtpnTransactionsComponent } from './components/rtpn-transactions/rtpn-transactions.component';
import { RtpnSimulatorComponent } from './components/rtpn-simulator/rtpn-simulator.component';

const routes: Routes = [
  { path: 'csr-account', component: CsrAccountComponent, canActivate: [authToken, requiredPrivilege], data: { privilege: 'PRIV_VP_ACCT_CSR' }},
  
  // { path: 'csr-account', loadComponent: () => import('./components/csr-account/csr-account.component')
  //   .then(c => c.CsrAccountComponent),
  //     canActivate: [authToken, requiredPrivilege], data: { privilege: 'PRIV_VP_ACCT_CSR' }
  // },
  
  { path: 'client-dashboard-tiles', component: ClientDashboardTilesComponent, canActivate: [authToken, requiredPrivilege], data: { privilege: 'PRIV_WR_STATS'} },
  { path: 'rtpn-transactions', component: RtpnTransactionsComponent,
      canActivate: [authToken, requiredPrivilege], data: { privileges: ['PRIV_VP_RTPN_VIEWER'] }
  },
  { path: 'rtpn-simulator', component: RtpnSimulatorComponent,
      canActivate: [authToken, requiredPrivilege], data: { privileges: ['PRIV_RTPN_TEST'] }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ClientWorkspaceRoutingModule { }
